import get from 'lodash/get';
import { all, takeEvery } from 'redux-saga/effects';
// import { serializeError } from 'serialize-error';
import audioVideoChannelWatcher from 'store/audioVideo/audioVideoChannels';
import audioVideoWatcher from 'store/audioVideo/audioVideoFlowSagas';
import conferenceWatcher from 'store/conference/conferenceFlowSagas';
import messageWatcher from 'store/message/messageFlowSagas';
import videoWatcher from 'store/video/videoFlowSagas';
import chimeWatcher from './chime/chimeFlowSagas';
import classroomWatcher from './classroom/classroomFlowSagas';
import moodleWatcher from './moodle/moodleFlowSagas';
import userWatcher from './user/userFlowSagas';

function* logActions(data) {
  // let methodName = get(data, 'payload.key', '');
  let [storeGroup, actionName] = get(data, 'type', '/').split('/'); //eslint-disable-line
  if (actionName === 'initAction') {
    // console.log(`${storeGroup}/${methodName}: Started`);
  } else if (actionName === 'successAction') {
    // console.log(`${storeGroup}/${methodName}: Successfull`);
  } else if (actionName === 'errorAction') {
    // let error;
    // try {
    //   error = serializeError(get(data, 'payload.error', {}));
    // } catch (e) {
    //   error = {};
    // }
    // console.error(`${storeGroup}/${methodName}: Error`, error);
  } else {
    // console.log(`${storeGroup}/${actionName}`, { payload: get(data, 'payload', {}) });
  }
  yield;
}

export default function* rootSaga() {
  yield all([
    moodleWatcher(),
    takeEvery('*', logActions),
    userWatcher(),
    classroomWatcher(),
    chimeWatcher(),
    audioVideoChannelWatcher(),
    messageWatcher(),
    videoWatcher(),
    audioVideoWatcher(),
    conferenceWatcher(),
  ]);
}
